import React from 'react';
import PropTypes from 'prop-types';

/** The workspace's Settings tab: rename and delete (the owner's), for now. */
export default function WorkspaceSettings({ workspace, canManage, onRename, onDelete }) {
  if (!canManage) {
    return <p className="workspaces-note">Only the workspace's owner can rename or delete it.</p>;
  }
  return (
    <div className="ws-settings">
      <section className="ws-card">
        <h2 className="ws-card-title">Name</h2>
        <p className="workspaces-note">{workspace.name}</p>
        <button className="ws-btn" onClick={onRename} type="button">Rename workspace</button>
      </section>
      <section className="ws-card">
        <h2 className="ws-card-title">Delete workspace</h2>
        <p className="workspaces-note">Its projects are kept, with their owners and the people they are shared with directly. Its members lose the access the workspace gave them.</p>
        <button className="ws-btn is-stop" onClick={onDelete} type="button">Delete workspace…</button>
      </section>
    </div>
  );
}

WorkspaceSettings.propTypes = {
  canManage: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  onRename: PropTypes.func.isRequired,
  workspace: PropTypes.object.isRequired,
};
